<template>
  <div :class="$style.article">
    <aw-aggregated-pages-cards
      :page-type="content.articleType"
      :params="{
        limit: content?.articleCount || 12,
        highlighted: null
      }"
      hide-load-more-button
      :analytics-banner-interaction="analyticsBannerInteraction"
      :analytics-measurable="analyticsMeasurable"
    />
    <div :class="$style.articleButton">
      <lv-button
        styling="secondary-dark"
        shrink
        :href="navigateButton.href"
        v-on="clickEventHandlers"
      >
        {{ navigateButton.text }}
      </lv-button>
    </div>
  </div>
</template>

<script>
  import analyticsBannerInteractionMixin from '~~/common/mixins/analyticsBannerInteractionMixin';
  import { createThrottledSendBannerViewInteraction, genBannerInteractionClickEventHandlers } from '~~/common/utils/bannerInteractionAnalytics';
  import AwAggregatedPagesCards from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageCards.vue';
  import { LvButton } from '~~/common/components/loginet-vue-shop/index';
  import { AnalyticsBannerInteraction } from '~~/common/utils/AnalyticsBannerInteraction';

  export default {
    name: 'AwArticleList',
    components: {
      AwAggregatedPagesCards,
      LvButton,
    },
    mixins: [analyticsBannerInteractionMixin],
    props: {
      content: {
        type: Object,
        required: true,
      },
    },
    computed: {
      navigateButton () {
        const buttonOptions = {
          press_release: {
            href: this.$localePath('press'),
            text: this.$awt('aw.common.article_list.button.press'),
            promotionName: this.$awt('aw.common.article_list.show_all_articles.promotion_name.press'),
          },
          news: {
            href: this.$localePath('news'),
            text: this.$awt('aw.common.article_list.button.news'),
            promotionName: this.$awt('aw.common.article_list.show_all_articles.promotion_name.news'),
          },
          career_news: {
            href: this.$localePath('karrier-hirek'),
            text: this.$awt('aw.common.article_list.button.career_news'),
            promotionName: this.$awt('aw.common.article_list.show_all_articles.promotion_name.career_news'),
          },
          csr: {
            href: this.$localePath('/csr'),
            text: this.$awt('aw.common.article_list.button.csr'),
            promotionName: this.$awt('aw.common.article_list.show_all_articles.promotion_name.csr'),
          },
          inspiration: {
            href: this.$localePath('inspirations'),
            text: this.$awt('aw.common.article_list.button.inspiration'),
            promotionName: this.$awt('aw.common.article_list.show_all_articles.promotion_name.inspiration'),
          },
          default: {
            href: this.$localePath('/'),
            text: this.$awt('aw.common.article_list.button.default'),
            promotionName: this.$awt('aw.common.article_list.show_all_articles.promotion_name.default'),
          },
        };
        return buttonOptions?.[this.content?.articleType] || buttonOptions.default;
      },
      buttonAnalyticsBannerInteraction () {
        return AnalyticsBannerInteraction.create({
          ...this.analyticsBannerInteraction,
          promotionBannerIndex: this.$awt('aw.common.article_list.show_all_articles.promotion_banner_index'),
          promotionName: this.navigateButton.promotionName,
        });
      },
      clickEventHandlers () {
        return genBannerInteractionClickEventHandlers({
          analyticsBannerInteraction: this.buttonAnalyticsBannerInteraction,
          analyticsMeasurable: this.analyticsMeasurable,
        });
      },
    },
    mounted () {
      createThrottledSendBannerViewInteraction()({
        analyticsMeasurable: this.analyticsMeasurable,
        analyticsBannerInteraction: this.buttonAnalyticsBannerInteraction,
      });
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.article {
  &Button {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    @include tablet(min) {
      margin-top: 40px;
    }
  }
}
</style>
